import type { TranslationKey } from 'localization'

export type Scorecard = {
  metricName: string
  scorecardBand: string
  score: number
  updatedAt: Date
}

export const RETURN_RATE_METRIC_NAME = 'overall_z_score_return_rate'
export const COMMITMENT_RATE_METRIC_NAME = 'commitment_rate'
export const ON_TIME_RATE_METRIC_NAME = 'timeliness'

export function getScorecardByMetricName(scorecardSummary: Scorecard[], metricName: string): Scorecard | undefined {
  return scorecardSummary.find((s) => s.metricName === metricName)
}

const ScorecardBandToStatusKey: Record<string, TranslationKey> = {
  acceptable: 'dweb_scorecard_status_acceptable',
  coaching: 'dweb_scorecard_status_needs_improvement',
  abuser: 'dweb_scorecard_status_unacceptable',
}

export const getScorecardStatusKey = (scorecardBand: string): TranslationKey | undefined => {
  return ScorecardBandToStatusKey[scorecardBand]
}

export type StatColor = 'success-dark' | 'success-base' | 'alert-dark' | 'alert-base' | 'error-dark' | 'error-base'

export function getStatColor(
  rate: number,
  isDarkMode: boolean,
  successThreshold: number,
  alertThreshold: number
): StatColor {
  if (rate >= successThreshold) return isDarkMode ? 'success-base' : 'success-dark'
  if (rate >= alertThreshold) return isDarkMode ? 'alert-base' : 'alert-dark'
  return isDarkMode ? 'error-base' : 'error-dark'
}
